(function ($) {
  $hero = $('.hero-banner');

  if ($hero.length > 0) {
    if ($hero.find('.field--name-field-media-oembed-video').length > 0) {
      $hero.parent().addClass('hero-banner-wrapper')
    } else {
      $hero.parent().addClass('hero-banner-wrapper wimage')
    }
  }
}(jQuery));
